import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Button';
import './SuccessModal.css';
import SuccessIcon from '../../../assets/svg/check-contained.svg';
import WarningIcon from '../../../assets/svg/alert-circle.svg';
import MatchIcon from '../../../assets/svg/checkmark-circle-green.svg';
interface successModalProps {
    successHeader: string;
    closeSuccessModal: () => void;
    typeModal: 'success' | 'warning' | 'match';
    successButtonName:string
}
const SucessModalComponent: React.FC<successModalProps> = ({
    successHeader,
    closeSuccessModal,
    typeModal,
    successButtonName
}) => {
    const [show, setShow] = useState<boolean>(true);
    const handleClose = () => setShow(false);
    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
            
                dialogClassName={`success_modal ${typeModal}`}
            >
                <Modal.Body className="success_modal_body">
                    {typeModal === 'success' && (
                        <span className="success_modal_icon"><div className='success_icon'><SuccessIcon className='successIcon'/></div><div className='success_text'>{successHeader}</div></span>
                    )}
                    {typeModal === 'warning' && (
                        <span className="success_modal_icon"><div className='warning_icon'><WarningIcon className='warningIcon' /></div><div className='success_text'>{successHeader}</div></span>
                    )}
                    {typeModal === 'match' && (
                        <span className="success_modal_icon"><div className='match_icon'><MatchIcon className='matchIcon' /></div><div className='success_text'>{successHeader}</div></span>
                    )}
                     </Modal.Body>
                     <Modal.Footer className="success_modal_footer">
                    <Button
                        onClick={closeSuccessModal}
                        disabled={false}
                        id=""
                        buttonName={successButtonName}
                        colorType={'previous'}
                    />
                    </Modal.Footer>
            </Modal>
        </div>
    )
}
export default SucessModalComponent;